import { routeCatalog } from "../catalog/route-catalog.ts";
import { routeParameter } from "../route-parameter.ts";

function patternSpecificity(path: string): number {
  return path
    .split("/")
    .filter(Boolean)
    .reduce((score, segment) => {
      const parameter = routeParameter(segment);
      return (
        score +
        (parameter ? Number(Boolean(parameter.prefix || parameter.suffix)) : 2)
      );
    }, 0);
}

export const definitions = Object.entries(routeCatalog).toSorted(
  ([, left], [, right]) =>
    patternSpecificity(right.path) - patternSpecificity(left.path),
);

export const areasByBucket = {
  app: "product",
  admin: "admin",
  marketing: "marketing",
  docs: "docs",
  unlisted: "office",
  catalog: "game",
} as const;
